import script from "./EmployeeCount.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeCount.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeCount.vue?vue&type=style&index=0&id=258fcf42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258fcf42"]])

export default __exports__